import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import DialogFactory from '../picker/dialogFactory';
import IPSDialog from '../picker/dialog';
import style from './style.vue';
import { IPSService } from '@/services/ipsServices';
import { Functions } from '@/library/utils/functions';

const MiniPageListService = ['miniPageList', 'miniPageList', 'miniPageList', 'siteMicroPageList', 'miniPageList'];
@DialogFactory
@Component({
  mixins: [style],
})
export default class MiniPage extends IPSDialog {
  sgId = 0;

  page = 1;

  pageSize = 10;

  total = 0;

  dataList = [];

  keyword = '';

  siteCodes = [];

  confirm = false;

  title = '微页面列表';

  width = '800px';

  cancelText = '关闭';

  // 运营模式 1 镜单  2 镜千 3 云单 4 云千
  mode = 2;

  // 网点Id
  siteId = 0;
  date = [];

  public defaultStart: Date;

  public defaultEnd: Date;

  mounted() {
    this.getDataList();
  }

  getDataList() {
    const postParams = {
      sgId: this.sgId,
      siteId: this.siteId,
      page: this.page,
      pageSize: this.pageSize,
      keyword: this.keyword,
      pageState: 1,
    };
    IPSService[MiniPageListService[this.siteId ? 3 : 2]]({ postParams }).then((response) => {
      this.dataList = response.list.map((v) => {
        v.pageStateStr = v.pageState ? '可用' : '不可用';
        v.updateTimeStr = Functions.timeFormat(v.updateTime);
        return v;
      });
      this.total = response.count;
    });
  }

  onSizeChange(val) {
    this.pageSize = val;
    this.getDataList();
  }

  onPageChange(val) {
    this.page = val;
    this.getDataList();
  }

  onSelect(ptId, ptName) {
    this.$emit('result', { id: ptId, name: ptName });
    this.$emit('hidden');
  }

  handleSearch() {
    this.page = 1;
    this.getDataList();
  }

  renderContent(h) {
    return (
      <div class="select-list">
        <div class="filterController">
          <div class="inputWrapper">
            <el-input v-model={this.keyword}></el-input>
            <i class="iconfont iconsousuo" onClick={this.handleSearch.bind(this)}></i>
          </div>
          {/* <div class="inputWrapper wid-300">
            <span class="font-size-14 r-ml-10">更新时间</span>
            <el-date-picker v-model={this.date} type="daterange" format="yyyy 年 MM 月 dd 日" onChange={this.getDataList} range-separator="~" />
          </div> */}
        </div>
        <el-table data={this.dataList} height="350px" style="width: 100%" tooltip-effect="light">
          <el-table-column type="index" label="ID" width="40" />
          <el-table-column prop="pageId" label="页面ID" show-overflow-tooltip width="120px" align="center" />
          <el-table-column prop="pageName" label="页面名称" show-overflow-tooltip width="240px" align="left" />
          <el-table-column prop="pageStateStr" label="状态" show-overflow-tooltip width="60px" align="center" />
          <el-table-column prop="updatePerson" label="更新人" show-overflow-tooltip width="120px" align="center" />
          <el-table-column prop="updateTimeStr" label="更新时间" show-overflow-tooltip width="140px" align="center" />
          <el-table-column
            label="操作"
            width="80px"
            {...{
              scopedSlots: {
                default: (scope) => {
                  return (
                    <span class="scopeSpan" onClick={this.onSelect.bind(this, scope.row.pageId, scope.row.pageName)}>
                      选中
                    </span>
                  );
                },
              },
            }}></el-table-column>
        </el-table>
        <div class="bottomWrapper">
          <el-pagination
            on-size-change={val => this.onSizeChange(val)}
            on-current-change={val => this.onPageChange(val)}
            current-page={this.page}
            page-sizes={[10, 15, 20, 30]}
            page-size={this.pageSize}
            layout="total, sizes, prev, pager, next, jumper"
            total={this.total}></el-pagination>
        </div>
      </div>
    );
  }
}
